
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"160","height":"160"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M92.044 94.264h-26.8A5.292 5.292 0 0159.934 89V76a5.292 5.292 0 015.309-5.265h4.6l7.08-15.792a1.571 1.571 0 011.434-.919 7.156 7.156 0 017.179 7.119v5.878l9.044.009a6.238 6.238 0 01.84.062 5.269 5.269 0 013.472 2.083 5.188 5.188 0 01.978 3.909L97.294 89.8a5.338 5.338 0 01-5.25 4.464zm-19.615-3.1h19.662a2.2 2.2 0 002.114-1.836l2.579-16.712a2.12 2.12 0 00-.4-1.606 2.183 2.183 0 00-1.427-.857 1.873 1.873 0 00-.225-.016l-.153-.009-10.6-.006a1.558 1.558 0 01-1.561-1.551v-7.429a4.029 4.029 0 00-3.095-3.906l-6.9 15.378zm-7.183-17.328A2.176 2.176 0 0063.064 76v13a2.174 2.174 0 002.183 2.164h4.06V73.835z"}})])
          )
        }
      }
    